import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { inventoryService } from '../services/inventoryService';
import type { InventoryItem } from '@clinic-os/shared/types';

export const INVENTORY_KEY = ['inventory'] as const;

export function useInventory() {
  return useQuery({
    queryKey: INVENTORY_KEY,
    queryFn: () => inventoryService.getAll(),
  });
}

export function useLowStockItems() {
  return useQuery({
    queryKey: [...INVENTORY_KEY, 'lowstock'],
    queryFn: () => inventoryService.getLowStock(),
  });
}

export function useCreateInventoryItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Omit<InventoryItem, 'id' | 'createdAt' | 'updatedAt'>) =>
      inventoryService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: INVENTORY_KEY }),
  });
}

export function useUpdateInventoryItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<InventoryItem> }) =>
      inventoryService.update(id, data),
    onSuccess: (_, { id }) => {
      qc.invalidateQueries({ queryKey: INVENTORY_KEY });
      qc.invalidateQueries({ queryKey: [...INVENTORY_KEY, 'lowstock'] });
    },
  });
}
